import axiosClient from "utils/api";

const URI = "/admin/plan";

export const getUserPlan = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Get All Report Category:", error);
    throw error;
  }
};

export const addUserPlan = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Get All Report Category:", error);
    throw error;
  }
};

export const deleteUserPlan = async (payload) => {
  const URL = `${URI}/${payload.id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "delete",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Get All Report Category:", error);
    throw error;
  }
};

export const updateUserPlan = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URI}/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Get All Report Category:", error);
    throw error;
  }
};

export const getUserPlanDetail = async (id) => {
  const URL = `${URI}/getDetails/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
    });

    return response.data;
  } catch (error) {
    console.error("Error occurred Get User Plan Detail:", error);
    throw error;
  }
};
